import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';
import { GoogleAuthInputs } from '../api/auth.api';

const initialState: Partial<GoogleAuthInputs> = {};

const googleDataSlice = createSlice({
  name: 'googleData',
  initialState,
  reducers: {
    setGoogleData: (state, action) => {
      return action.payload;
    },
    resetGoogleData: () => {
      return initialState;
    },
  },
});

export const { resetGoogleData, setGoogleData } = googleDataSlice.actions;

export const getGoogleData = (state: RootState) => state.googleData;

export default googleDataSlice.reducer;
